module.exports = __webpack_public_path__ + "media/images/products/demo/slideri4-b75e6c136110630b4aeebda7247d6bab.jpg";